$('.alert.fade').each(function() {
    setTimeout(() => {
        $(this).fadeOut(1000);
    }, 5000);
})

$('.alert .close').click(function() {
    $(this).parent().hide();
})

$(document).ready(function() {
    $('.navbar-minimalize').click(function() {
        if (typeof(Storage) !== "undefined") {
            if(localStorage.getItem("navclosed") == "closed" || localStorage.getItem("navclosed") == null) {
                localStorage.setItem("navclosed", "open");
            }
            else {
                localStorage.setItem("navclosed", "closed");
            }
        }
    });

    if (typeof(Storage) !== "undefined") {
        if(localStorage.getItem("navclosed") && localStorage.getItem("navclosed") == "closed") {
            $("body").addClass("mini-navbar")
        }
    }
});


/**
 * Sets the height of all elements matching the selector to the highets height of the element
 * @param selector
 */
export function setSameHeight(selector){
   let maxHeight =  Math.max( $(selector).map( ()=>{
        return $(this).height();
    }).get())

    $(selector).height(maxHeight)
}
